/**
 * Check if a select input is valid
 * @param {HTMLSelectElement} select
 * @returns {boolean}
 */

export function checkSelectValidity(select) {
  if (select.required && (select.value === '' || select.value === 'default')) {
    return false
  }
  return true
}
